import React, { useEffect, useState } from 'react'
import { MutatingDots } from 'react-loader-spinner';
import { Link } from 'react-router-dom';

export const AboutContainer = () => {
    const [loading, setLoading] = useState(true);
    const BASE_URL = process.env.PUBLIC_URL;
    useEffect(() => {
        const loadingTimeout = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(loadingTimeout);
    }, []);


    return (
        <section className=''>
            {loading ? ( 
                    <div className='flex justify-center items-center	 spinner'>
                        <MutatingDots 
                        height="100"
                        width="100"
                        color="#570DF8"
                        secondaryColor= '#2F2E41'
                        radius='12.5'
                        ariaLabel="mutating-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        />
                    </div> 
                ):
                <>
                    <article className='flex justify-center items-center flex-row sm:flex-col'>
                        <div className='w-2/5	m-10 sm:w-4/5 md:w-3/5 xl:w-3/5 2xl:w-1/5'>
                            <h2 className='text-7xl	font-medium	text-white text-center sm:text-3xl md:text-5xl xl:text-4xl'>FULLSTACK DEV</h2>
                        </div>
                        <div className="card w-2/5	m-10 bg-base-100 shadow-xl border-2 border-sky-500 sm:w-4/5 md:w-3/5 xl:w-3/5 2xl:w-1/5">
                            <figure className='aboutContainer'><img src={`${BASE_URL}/assets/images/dev.svg`} alt='Imagen animada de un programador' className='object-contain w-4/5 h-4/5 '/></figure>
                            <div className="card-body">
                                <h2 className="card-title md:h-24 xl:h-24">Hola!</h2>
                                <p className=' sm:h-52 md:h-80 lg:h-48 '>Soy un programador apasionado y colaborador, capaz de adaptarme a cualquier situación. Me encanta resolver problemas y enfrentar nuevos desafíos, siempre buscando aprender nuevas tecnologías para mejorar y crecer como profesional.</p>
                            </div>
                        </div>
                    </article>
                    <article className='flex justify-center items-center  flex-row sm:flex-col'>
                        <div className="card w-2/5	m-10 bg-base-100 shadow-xl border-2 border-sky-500 sm:w-4/5 md:w-3/5 xl:w-3/5 2xl:w-1/5">
                            <figure className='aboutContainer'><img src={`${BASE_URL}/assets/images/teamWork.svg`} alt='Imagen animada de dos programadores' className='object-contain w-4/5 h-80 md:w-3/5 h-4/5 lg:h-56 xl:h-60 2xl:h-80'/></figure>
                            <div className="card-body">
                                <h2 className="card-title md:h-36 lg:h-24 xl:h-32">Team player</h2>
                                <p className='h-48 sm:h-52 md:h-80 lg:h-48 xl:h-52'>Disfruto de trabajar en equipo y colaborar con otros profesionales para crear soluciones innovadoras y efectivas.</p>
                            </div>
                        </div>
                        <div className="card w-2/5	m-10 bg-base-100 shadow-xl border-2 border-sky-500 sm:w-4/5 md:w-3/5 xl:w-3/5 2xl:w-1/5">
                            <figure className='aboutContainer'><img src={`${BASE_URL}/assets/images/tutor.svg`} alt='Imagen animada de un programador enseñando' className='object-contain w-4/5 h-80 md:w-3/5 h-4/5 lg:h-56 xl:h-60 2xl:h-80'/></figure>
                            <div className="card-body">
                                <h2 className="card-title md:h-32 lg:h-24 xl:h-32">Compartiendo conocimientos y creciendo juntos</h2>
                                <p className='h-48 sm:h-52 md:h-80 lg:h-48 xl:h-52'>Ser tutor me enseñó que disfruto ayudando a otros programadores a mejorar y, al mismo tiempo, aprendiendo de ellos. Me apasiona compartir mis conocimientos y experiencias con los demás, y creo que el aprendizaje mutuo es la clave para el crecimiento personal y profesional</p>
                            </div>
                        </div>
                    </article>
                    <article className='flex justify-center items-center flex-row sm:flex-col'>
                        <div className="mockup-window border bg-base-300 w-2/5	m-10 shadow-xl sm:w-4/5 md:w-3/5 xl:w-3/5 2xl:w-1/5">
                            <div className="flex justify-center px-4 py-16 bg-base-200">Al igual que muchas otras personas, la pandemia me obligó a buscar nuevos caminos. Descubrí mi interés por la programación y decidí enfocar mi carrera en esta área en constante evolución. Estoy fascinado por el proceso de creación de soluciones innovadoras a través del código y emocionado por seguir aprendiendo y creciendo como programador.
                            </div>
                        </div>
                    </article>
                    <div className="flex justify-center align-center pb-5">
                        <Link to='/recruiter' className="btn btn-primary flex justify-self-center	 self-center	w-1/5">Volver</Link>
                    </div>
                </>
            }
        </section>
    )
}
